import { styled } from '@mui/material/styles';

// Disable all fields during provisioning, including the injected upload controls.
export const FormFieldset = styled('fieldset')({
  padding: 0,
  margin: 0,
  border: 0,
  minWidth: 0,
});
